import { Helmet } from "react-helmet";
import Navbar from "../components/universal/navbar";
import Header from "../components/terms-of-use/hero";
import PP from "../components/terms-of-use/content";
import CTA from "../components/universal/cta";
import Contact from "../components/universal/contact";
import Footer from "../components/universal/footer";

function Index() {
  return (
    <div>
      <Helmet>
        <title>Dental Implants in Ilkley | Terms of Use</title>
        <link
          rel="canonical"
          href="https://www.dentalimplants-ilkley.com/terms-of-use"
        />
        <meta
          name="description"
          content="Explore the terms and conditions for using Dental Implants Ilkley’s website to understand your rights and our responsibilities for a secure online experience."
        />
      </Helmet>
      <Navbar />
      <Header />
      <PP />
      <CTA />
      <Contact />
      <Footer />
    </div>
  );
}

export default Index;
